import Vue from 'vue'
import Cookies from 'js-cookie'
import axios from 'axios'
import App from './App'
import router from './router'
import * as FullStory from '@fullstory/browser'

FullStory.init({ orgId: 'X1XZ9' })
Vue.prototype.$FullStory = FullStory

Vue.config.productionTip = false

const server = process.env.SERVER || ''

const loadPage = () => {
  return new Vue({
    el: '#app',
    router,
    render: h => h(App)
  })
}

if (Cookies.get('token')) {
  axios.post(server + '/token', {
    token: Cookies.get('token')
  }, {
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    if (response.data.status !== 'Success') {
      // If invalid token, redirect to login
      window.location.href = '/login'
    } else {
      if (window.location.pathname === '/login') {
        // Automatically redirect authorized user away from /login
        window.location.href = response.data.views[0].link
      } else if (response.data.views.map(view => view.link).indexOf(window.location.pathname) === -1) {
        // User not authorized to view page
        // Redirect user to an authorized page
        window.location.href = response.data.views[0].link
      } else {
        loadPage()
      }
    }
  })
  .catch(error => {
    console.log(error)
    if (window.location.pathname !== '/login') {
      window.location.href = '/login'
    } else {
      loadPage()
    }
  })
} else {
  // Redirect to login page
  if (window.location.pathname !== '/login') {
    window.location.href = '/login'
  } else {
    loadPage()
  }
}



// WEBPACK FOOTER //
// ./src/main.js